export enum SignalRHubs {
    NotificationsHub = "NotificationsHub",
}
